<template>
    <div class="comment">
        <span class="comment__user">{{ comment.user.name }} <span v-if="comment.site_name"> | {{ comment.site_name }}</span></span>
        <div 
            v-if="!editing" 
            class="comment__content" 
            v-html="html"
        />
        <textarea 
            v-if="editing" 
            name="comment_content" 
            class="comment__input" 
            rows="3" 
            v-model="content"
        />
        <span class="comment__time">
            <a 
                v-if="canEdit && !editing" 
                href="#" 
                @click.prevent="toggleEdit"
            >Edit</a>
            <a 
                class="text-danger"
                v-if="canDelete" 
                href="#" 
                @click.prevent="deleteComment"
            >Delete</a>
            <a 
                v-if="canEdit && editing" 
                href="#" 
                @click.prevent="save"
            >Save</a>
            <a 
                v-if="canEdit && editing" 
                href="#" 
                @click.prevent="toggleEdit"
            >Cancel</a>
            {{ timestamp }}
        </span>
        <div
            class="comment__attachments"
            v-if="comment.attachments && comment.attachments.length"
        >
            <div
                class="comment__attachment"
                v-for="(attachment, index) in comment.attachments"
                :key="attachment.id"
            >
                <a
                    :href="attachment.upload.full_url"
                    download
                    title="Download attachment"
                    target="_blank"
                ><i class="fa fa-paperclip" /> {{ attachment.upload.name }}</a>
                <button
                    class="btn btn-sm btn-outline-danger"
                    v-if="canEdit && editing"
                    @click="deleteAttachment(attachment, index)"
                >
                    <i class="fa fa-times" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Auth from '../services/AuthService';
import Service from '../services/CommentsService';
import AttachmentService from '../services/AttachmentsService';
import CommentsService from '../services/CommentsService';

export default {
    props: {
        comment: {
            required: true,
            type: Object
        }
    },

    data() {
        return {
            editing: false,
            content: '',
        };
    },

    computed: {
        timestamp() {
            if (this.comment.created_at) {
                return window.moment(this.comment.created_at).format('llll');
            }

            return 'Unknown';
        },

        canEdit() {
            return Auth.user.id == this.comment.user_id || Auth.user.admin_access;
        },

        canDelete() {
            return Auth.user.admin_access;
        },

        html () {
            return window.injectTelAndEmails(this.comment.content_html);
        },
    },

    methods: {
        toggleEdit() {
            if (!this.canEdit) {
                return;
            }
            this.editing = !this.editing;
            if(this.editing) {
                this.content = this.comment.content;
            }
        },

        save() {
            const comment = {
                ...this.comment,
                content: this.content,
            };
            Service.update(comment).then(() => {
                this.editing = false;
            });
        },

        deleteAttachment (attachment, index) {
            var confirm = window.confirm('Are you sure you want to delete this attachment?');
            if (!confirm) {
                return;
            }
            AttachmentService.delete(attachment.id).then(() => {
                this.comment.attachments.splice(index, 1);
            });
        },

        deleteComment() {
            const confirm = window.confirm('Are you sure you want to delete this comment?');
            if (!confirm) {
                return;
            }
            CommentsService.delete(this.comment).then(() => {
                this.$emit('deleted');
            }).catch(err => {
                window.alert('Error: Failed to delete comment');
                console.error(err);
            });
        },
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/CommentComponent.vue